<template>
	<div class="l-body">
		<top/>
	<!-- <div class="header">
	<div class="l-wrap">
	<a class="header__logo" href="https://www.zhaouc.com/" target="_blank">塔人网络</a>
	<el-dropdown class="news_nav">
		<span>
			游戏充值
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item><a href="http://pay.tarenwang.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://trpay.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<el-dropdown class="news_nav">
		<span>
			帐号管理
		</span>
		<el-dropdown-menu slot="dropdown">
		    <el-dropdown-item><a href="http://yht.zhaouc.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://roinfo.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<a class="news_nav" href="http://www.zhaouc.com/" target="_blank">塔人主站</a>
	<a class="news_nav" href="/">客服首页</a>
	</div>
	</div> -->
	<div class="wrap login_bg">
	<div class="login zheng">
	<div class="login_dl">
	<div class="dlfs">
	<h1>选择登录方式</h1>
	<a @click='$router.push({path:"/login"})'>一号通登录</a>
	<a @click='$router.push({path:"/vlogin"})'>奇迹MU（VIP区）登录</a>
	<a @click='$router.push({path:"/rologin"})'>仙境传说起源（普隆德拉）登录</a>
	<a @click='$router.push({path:"/mlogin"})'>魔力宝贝手机验证码登录</a>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	import top from '@/components/top1.vue'
	export default {
	  name: 'chooselogin',
	  components: {
	    top
	  },
	  data () {
	    return {

	    }
	  },
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chooselogin.vue